import { render } from "./SidebarPlottingKapal.vue?vue&type=template&id=31303be4"
import script from "./SidebarPlottingKapal.vue?vue&type=script&lang=js"
export * from "./SidebarPlottingKapal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__